import { ComponentWithAs, Heading, HeadingProps } from "@chakra-ui/react";
import React from "react";
import { BusStop } from "../../data/buses.api";

type Props = HeadingProps & {
  busStop: BusStop;
};

const BusStopHeading = ({ busStop, ...headerProps }: Props) => {
  return (
    <Heading {...headerProps}>
      {busStop.suburb}, {busStop.commonName}{" "}
      {busStop.identifier.toLowerCase().startsWith("stand")
        ? `(${busStop.identifier})`
        : null}
    </Heading>
  );
};

export default BusStopHeading;
